import * as React from "react";
import { useEffect, useState } from "react";
import { useAppSelector } from "../app/hooks";
import { useAppDispatch } from "../app/store";
import { apiSlice, BestAvailableModelQueryParams } from "../data/api/api";
import bestAvailableModelSlice from "../data/slices/best-available-model-slice";
import loadingSlice from "../data/slices/loading-slice";
import miniCartModelSlice from "../data/slices/mini-cart-slicer";


export const PerformanceDropdown: React.FC = () => {
    const bestAvailableText = useAppSelector((state) => state.bestAvailableText);
    const bestAvailableModel = useAppSelector((state) => state.bestAvailableModel);
    const [currentPerformanceList, setCurrentPerformanceList] = useState(bestAvailableModel.performances);
    const [selectedPerformance, setSelectedPerformance] = useState(bestAvailableModel.currentPerformance);
    const pageId = useAppSelector((state) => state.pageId);
    const dispatch = useAppDispatch();

    useEffect(() => { setCurrentPerformanceList(bestAvailableModel.performances) }, [bestAvailableModel.performances])
    useEffect(() => { setSelectedPerformance(bestAvailableModel.currentPerformance) }, [bestAvailableModel.currentPerformance])

    function onDropdownSelection(evt) {
        dispatch(loadingSlice.actions.setIsLoading(true));
        const newPerformanceId = evt.target.value;
        if (newPerformanceId === selectedPerformance.performanceId) {
            setTimeout(() => {
                dispatch(loadingSlice.actions.setIsLoading(false));
            }, 3000)
            return;
        }

        updatePerformanceIdUrlParam(newPerformanceId);
        getBestAvailableModel(newPerformanceId, bestAvailableModel.currentPerformance.productionSeasonId, pageId, bestAvailableModel.isExchange);
        dispatch(miniCartModelSlice.actions.clearMiniCart());
        setTimeout(() => {
            dispatch(loadingSlice.actions.setIsLoading(false));
        }, 2000)
    }

    const dispatchGetUpdatedModel = async (request: BestAvailableModelQueryParams) => {
        const response = await dispatch(apiSlice.endpoints.getBestAvailableModel.initiate(request, { forceRefetch: true })).unwrap();
        dispatch(bestAvailableModelSlice.actions.updateBestAvailableModel(response));
    }

    const getBestAvailableModel = (performanceId: number, productionSeasonId: number, pageId: number, isExchange = false) => {
        const request: BestAvailableModelQueryParams = {
            exchangeMode: isExchange,
            pageId: pageId,
            productionSeasonId: productionSeasonId,
            performanceId: performanceId
        };
        dispatchGetUpdatedModel(request);
    }

    const updatePerformanceIdUrlParam = (performanceId: number) => {
        const url = new URL(window.location.href);
        const performanceIdQuery = "performanceId";
        if (url.searchParams.has(performanceIdQuery) && url.searchParams.get(performanceIdQuery) != performanceId.toString()) {
            url.searchParams.set(performanceIdQuery, performanceId.toString());
        }

        window.history.replaceState(null, null, url);
    }

    if (bestAvailableModel.isExchange) {
        return null;
    }

    return (
        <div>
            <label htmlFor="performance-dropdown">{bestAvailableText.dateAndTimeLabel}</label>
            <select id="performance-dropdown" onChange={onDropdownSelection} defaultValue={selectedPerformance.performanceId}>
                {currentPerformanceList.map((perf) => (
                    <option key={perf.performanceId} value={perf.performanceId} disabled={perf.isDisabled}>
                        {perf.dateAndAvailability}
                    </option>
                ))}
            </select>
        </div>
    )
}